<p-confirmDialog header="{{'General.info' | translate}}" icon="pi pi-exclamation-triangle"
  acceptLabel="{{'General.accept' | translate}}" rejectLabel="{{'General.cancel' | translate}}" key="confirm2">
</p-confirmDialog>
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid  m-b-lg">
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
          </p-header>
          <div class="row">
            <form (keyup.enter)="load()" #element>
              <div class="col-12">
                <formElement [model]="filters" name="taxIdentifier"
                  [fieldConfig]="getFieldConfig(this.PARAM_TAXIDENTIFIER)" #ref>
                </formElement>
                <formElement [model]="filters" name="name" [fieldConfig]="getFieldConfig(this.PARAM_NAME)" #ref>
                </formElement>
                <formElement [model]="filters" name="ril" [fieldConfig]="getFieldConfigYesNo(this.PARAM_RIL)" #ref>
                </formElement>
              </div>
            </form>
            <div class="col-12 text-right"><button class="btn btn-primary fadeInRight" (click)="load(true)"><i
                  class="fas fa-search"></i> {{'General.search.text'|translate}}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <!-- zona de datos -->
        <p-panel>
          <p-header>
            <div class="row">
              <div class="col-12">
                <span class="m-xst float-right m-l-md leyenda" *ngIf="companyList">
                  {{'General.search.showing'|translate}} {{ companyList.length }} <span
                    *ngIf="pageInfo && pageInfo.totalElements > 0"> {{'General.search.showing1'|translate}} {{
                    pageInfo.totalElements }}</span></span>
              </div>
            </div>
          </p-header>
          <p-table #dt [value]="companyList" sortField="expedienteId" sortOrder="1" [scrollable]="false"
            responsiveLayout="scroll" [resizableColumns]="true" class="footer-over-pagination" dropdownAppendTo="body">
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'taxIdentifier'" style="width: 10%;"> {{ 'CompanyList.identifier' | translate }}
                </th>
                <th [pSortableColumn]="'name'" style="width: 40%;"> {{ 'CompanyList.name' | translate }} </th>
                <th [pSortableColumn]="'commercialName'" style="width: 40%;"> {{ 'CompanyList.commercialName' |
                  translate }} </th>
                <th [pSortableColumn]="'hasRilFile'" style="width: 40%;"> {{ 'CompanyList.ril.filter' | translate }}
                </th>
                <th class="action-button-2" style="width: 10%;"> </th>
                <!--th class=" action-column-2"></th>-->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-company>
              <tr>
                <td field="taxIdentifier"> {{company.taxIdentifier}} </td>
                <td field="name"> {{company.name}} </td>
                <td field="comercialName"> {{company.commercialName}} </td>
                <td field="hasRilFile"> {{company.hasRilFile?'Sí':'No'}} </td>
                <td class="action-column-2x text-right  w-50">
                  <!--div class="btn-group d-flex justify-content-end action-column text-right">
                    <button *ngIf="company.hasRilFile" class="btn btn-sm btn-primary t-action-button"
                      aria-expanded="false" (click)="openRilFile(company)"
                      pTooltip="{{ 'Ver expediente RIL' | translate }}" title="{{ 'Ver expediente RIL' | translate }}">
                      <i class="fa fa-archive"></i>
                    </button>


                  </div>-->
                  <pmenu-actions [dto]="company" [lazy]="true" [dtoType]="'COMPANY'"
                    [items]="getCompanyMenuItem(company)">
                  </pmenu-actions>
                </td>
                <!--td class="action-column-2x text-right  w-50">

                </td>-->
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="text-center">
                <td [attr.colspan]="4"> {{ 'General.noFilteredData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="text-center">
                <td [attr.colspan]="4" style="padding: 0; margin: 0; border: 0">
                  <p-paginator [rows]="pageInfo.size" [first]="pageInfo.number * pageInfo.size" dropdownAppendTo="body"
                    [totalRecords]="pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]"
                    (onPageChange)="reloadCompanies($event)"></p-paginator>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>